import React from "react";
import Topbar from "../Topbar";
import ImgHeader from "./ImgHeader";
import Banner1 from "./Banner1";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Banner2 from "./Banner2";
import Banner3 from "./Banner3";
import ImageBanner1 from "./ImageBanner1";
import Banner4 from "./Banner4";
import Banner5 from "./Banner5";
import ImageBanner2 from "./ImageBanner2";
import Contact from "../Contact";
import BannerImg from "../BannerImg";
import Footer from "../Footer";
import { Container } from "react-bootstrap";
import BG from "../../assets/Images/BG.jpg";
import SEO from "../SEO";

export default function About() {
  // Structured data for the about page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "About Kritika Goswamy Malik",
    description:
      "Learn about Kritika Goswamy Malik's formative journey in interior design, from her early career at Design & Development to her transformative experience with Max Hospitals project.",
    url: "https://kritikagoswamymalik.com/about",
    mainEntity: {
      "@type": "Person",
      "@id": "https://kritikagoswamymalik.com/#person",
      name: "Kritika Goswamy Malik",
      jobTitle: "Interior Designer",
      description:
        "Experienced interior designer with expertise in spatial storytelling and layout optimization, having worked on diverse projects including residential, corporate, hospitality, and healthcare spaces.",
      knowsAbout: [
        "Interior Design",
        "Spatial Storytelling",
        "Layout Optimization",
        "Residential Design",
        "Corporate Design",
        "Hospitality Design",
        "Healthcare Design",
        "Healing Environments",
      ],
      hasOccupation: {
        "@type": "Occupation",
        name: "Interior Designer",
        description:
          "Specializes in creating spaces that resonate with individuality through collaborative design journey",
      },
      alumniOf: {
        "@type": "Organization",
        name: "Design & Development",
        description: "Where she mastered the art of spatial storytelling",
      },
      hasWorkedOn: [
        {
          "@type": "Project",
          name: "Group 4 Securitas Corporate Floor Plans",
          description: "Corporate floor plan design and layout optimization",
        },
        {
          "@type": "Project",
          name: "CSC Corporate Interiors",
          description: "Corporate interior design project",
        },
        {
          "@type": "Project",
          name: "Accenture Office Design",
          description: "Corporate office space design",
        },
        {
          "@type": "Project",
          name: "Max Hospitals Interior Design",
          description: "Healthcare facility design including MRI room design",
        },
      ],
    },
  };

  return (
    <>
      <SEO
        title="About Kritika Goswamy Malik - Interior Designer Journey"
        description="Learn about Kritika Goswamy Malik's formative journey in interior design, from her early career at Design & Development to her transformative experience with Max Hospitals project. Discover her expertise in spatial storytelling and layout optimization."
        keywords="about kritika agoswamy malik, interior designer background, design journey, spatial storytelling, layout optimization, max hospitals, design development, healthcare design, corporate interiors"
        canonicalUrl="/about"
        structuredData={structuredData}
      />

      <Container
        fluid
        className="p-0"
        style={{
          backgroundColor: "#F5F5DC",
          backgroundImage: `url(${BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Topbar />
        <ImgHeader />
        <Banner1 />
        <Section1 />
        <Section2 />
        <Banner2 />
        <Banner3 />
        <ImageBanner1 />
        <Banner4 />
        <Banner5 />
        <ImageBanner2 />
        <Contact />
        <BannerImg />
        <Footer />
      </Container>
    </>
  );
}
